<template>
  <div class="login-status">
    <div class="user-chip" v-if="currentUser">
      <router-link to="/settings" class="user-chip__avatar">
        <user-avatar :name="currentUser.display_name" :src="currentUser.profile_image_url" />
      </router-link>
      <div class="user-chip__body">
        <router-link to="/settings" class="user-chip__name">{{ currentUser.display_name }}</router-link>
        <div class="user-chip__meta">
          <span v-if="currentBalance" class="user-chip__bal">
            {{ formatCurrency(currentBalance.total) }}
            <img :src="currencyIcon('sb')" alt="SwiftBUCKS" />
          </span>
          <span v-if="currentGoldBalance" class="user-chip__bal user-chip__bal--gold">
            {{ formatCurrency(currentGoldBalance.total) }}
            <img :src="currencyIcon('mt')" alt="SwiftGOLD" />
          </span>
        </div>
        <div v-if="!noDiscord && currentUser.discord_display_name" class="user-chip__discord">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
            <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z"></path>
          </svg>
          {{ currentUser.discord_display_name }}
        </div>
      </div>
      <discord-btn v-if="noDiscord" class="user-chip__add-discord" title="Connect your Discord"></discord-btn>
    </div>
    <login-btn v-else>Login</login-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import UserAvatar from './User-Avatar'

export default {
  name: 'login-status',
  components: {
    UserAvatar
  },
  computed: Object.assign(mapState([
    'currentUser', 'currentBalance', 'currentGoldBalance'
  ]), {
    noDiscord () {
      return this.currentUser && !this.currentUser.has_discord
    }
  }),
  methods: {
    currencyIcon (priceCurrencyType) {
      let image = priceCurrencyType === 'mt' ? 'swiftGold.png' : 'swiftBucks.png'

      return `${Vue.config.WEB_ASSET_BASE_URL}/${image}`
    }
  }
}
</script>

<style scoped>
.login-status {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 12px 5px 5px;
  border: 1px solid var(--sl-line-strong);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.03);
  text-align: left;
}

.user-chip__avatar {
  display: block;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  padding: 2px;
  background: linear-gradient(135deg, var(--sl-red), var(--sl-purple));
  box-sizing: border-box;
}


.user-chip__body {
  min-width: 0;
  line-height: 1.15;
}

.user-chip__name {
  font-family: var(--sl-font-cond);
  font-weight: 800;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
}

.user-chip__name:hover {
  color: var(--sl-link);
}

.user-chip__meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 2px;
  font-size: 12.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--sl-muted);
  white-space: nowrap;
}

.user-chip__bal--gold {
  color: var(--sl-gold);
}

.user-chip__meta img {
  width: 12px;
  vertical-align: -1px;
}

.user-chip__discord {
  margin-top: 2px;
  font-size: 11.5px;
  color: var(--sl-dim);
  white-space: nowrap;
}

.user-chip__discord svg {
  vertical-align: -2px;
}

.user-chip__add-discord {
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Login-Status.vue